var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
      },
    },
    [
      _c("path", {
        attrs: {
          d: "M7.05625 14.6313L6.97813 14.5594L1.50312 9.475C0.54375 8.58438 0 7.33438 0 6.025V5.92188C0 3.72188 1.5625 1.83438 3.725 1.42188C4.95625 1.18438 6.21562 1.46875 7.21875 2.175C7.5 2.375 7.7625 2.60625 8 2.87188C8.13125 2.72188 8.27188 2.58438 8.42188 2.45625C8.5375 2.35625 8.65625 2.2625 8.78125 2.175C9.78438 1.46875 11.0437 1.18438 12.275 1.41875C14.4375 1.83125 16 3.72188 16 5.92188V6.025C16 7.33438 15.4563 8.58438 14.4969 9.475L9.02188 14.5594L8.94375 14.6313C8.6875 14.8688 8.35 15.0031 8 15.0031C7.65 15.0031 7.3125 14.8719 7.05625 14.6313ZM7.47188 4.53125C7.45938 4.52188 7.45 4.50938 7.44063 4.49688L6.88438 3.87188L6.88125 3.86875C6.15937 3.05938 5.06875 2.69063 4.00625 2.89375C2.55 3.17188 1.5 4.44063 1.5 5.92188V6.025C1.5 6.91563 1.87188 7.76875 2.525 8.375L8 13.4594L13.475 8.375C14.1281 7.76875 14.5 6.91563 14.5 6.025V5.92188C14.5 4.44375 13.45 3.17188 11.9969 2.89375C10.9344 2.69063 9.84062 3.0625 9.12187 3.86875C9.12187 3.86875 9.12187 3.86875 9.11875 3.87188C9.11562 3.875 9.11875 3.87188 9.11563 3.875L8.55937 4.5C8.55 4.5125 8.5375 4.52188 8.52812 4.53438C8.3875 4.675 8.19687 4.75313 8 4.75313C7.80312 4.75313 7.6125 4.675 7.47188 4.53438V4.53125Z",
          fill: "#717986",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }